import React from "react"
import { IconButton, IconButtonProps } from "@mui/material"
import ClearIcon from "@mui/icons-material/Clear"

interface Props extends Omit<IconButtonProps, "onClick"> {
  onClose: () => void
}

export const CloseModalIconButton = ({ onClose, ...rest }: Props) => {
  return (
    <IconButton
      onClick={onClose}
      sx={{ color: "text.primary", "&:hover": { backgroundColor: "transparent" } }}
      {...rest}
    >
      <ClearIcon fontSize="large" />
    </IconButton>
  )
}
